import React from "react";
import { List } from "@material-ui/core";
import { NavLink, useRouteMatch } from "react-router-dom";

import IntlMessages from "../../util/IntlMessages";

const NavMenuItem = (props) => {
    const { name, icon, link, migrated } = props;
    const isActive = !!useRouteMatch(link);

    const content = (
        <>
            {!!icon && <i className={"zmdi zmdi-hc-fw  zmdi-" + icon} />}
            <span className="nav-text">
                <IntlMessages id={name} />
            </span>
        </>
    );

    return (
        <List component="div" className="nav-menu-item">
            {migrated ? (
                <a className={"prepend-icon nav-menu-link" + (isActive ? " active" : "")} href={link}>
                    {content}
                </a>
            ) : (
                <NavLink className="prepend-icon nav-menu-link" to={link}>
                    {content}
                </NavLink>
            )}
        </List>
    );
};

export default NavMenuItem;
